import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    closeTempRoute,
    isTempRouteOpen,
    getTempRouteParams
} from 'spark-state/common/app/reducer';

const TemporaryRoute = ({ name, render, component: Component, children }) => {
    const isOpen = useSelector(state => isTempRouteOpen(state, name));
    const params = useSelector(state => getTempRouteParams(state, name));
    const dispatch = useDispatch();
    const goBack = useCallback(() => dispatch(closeTempRoute(name)), [dispatch, name]);

    if (isOpen) {
        return (
            (render && render({ params, goBack })) ||
            (children && children({ params, goBack })) || (
                <Component goBack={goBack} params={params} />
            )
        );
    }
    return null;
};

export default TemporaryRoute;
